import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ListOrdered, Sparkles } from "lucide-react";
import { disciplineStage } from "../../api/penalties";

const ORDER = ["warning", "first_warning", "final_warning", "termination", "dismissal"];

// السجل التأديبي والمسار التصاعدي: الدرجات الخمس مع إبراز الدرجة المطلوبة تالياً للموظف المحدَّد.
export const DisciplineLadder = ({ userId }) => {
  const { t } = useTranslation();
  const [stage, setStage] = useState(null);

  useEffect(() => {
    if (!userId) return setStage(null);
    disciplineStage(userId).then(setStage).catch(() => setStage(null));
  }, [userId]);

  const hasEmp = Boolean(userId);
  const lastIdx = stage ? stage.last_severity_index : -1;
  const nextIdx = Math.min(lastIdx + 1, ORDER.length - 1);

  return (
    <div className="grid gap-3 rounded-3xl p-4 shadow-neu-in sm:col-span-2" data-testid="discipline-ladder">
      <div className="flex items-center justify-end gap-2">
        <h4 className="text-sm font-black">{t("penalty.ladder.title")}</h4>
        <ListOrdered className="h-4 w-4 text-primary" />
      </div>
      <div className="flex items-stretch justify-center gap-1 overflow-x-auto pb-1">
        {ORDER.map((key, i) => {
          const isNext = hasEmp && i === nextIdx;
          const done = hasEmp && i <= lastIdx;
          const tone = isNext
            ? "border-2 border-emerald-400 bg-emerald-50 text-emerald-700"
            : done
              ? "bg-amber-100/60 text-amber-700"
              : "bg-background text-muted-foreground";
          return (
            <div key={key} className="flex items-center gap-1">
              <div className={`grid min-w-[80px] place-items-center gap-0.5 rounded-2xl px-2 py-3 text-center shadow-neu-sm ${tone}`}
                   data-testid={`ladder-step-${key}`}>
                <span className="num text-base font-black">{i + 1}</span>
                <span className="text-[11px] font-bold leading-tight">{t(`penalty.types.${key}`)}</span>
                {isNext ? (
                  <span className="flex items-center gap-0.5 text-[10px] font-black">
                    <Sparkles className="h-3 w-3" /> {t("penalty.ladder.next")}
                  </span>
                ) : null}
              </div>
              {i < ORDER.length - 1 ? <span className="self-center text-muted-foreground">—</span> : null}
            </div>
          );
        })}
      </div>
      <p className={`rounded-2xl px-3 py-2 text-center text-xs font-bold ${
        !hasEmp ? "text-muted-foreground"
          : lastIdx < 0 ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}
         data-testid="ladder-status">
        {!hasEmp
          ? t("penalty.ladder.hint")
          : lastIdx < 0
            ? t("penalty.ladder.clean", { first: t(`penalty.types.${ORDER[0]}`) })
            : t("penalty.ladder.status", {
                current: t(`penalty.types.${stage.last_severity_type}`),
                next: t(`penalty.types.${stage.next_severity_type}`),
              })}
      </p>
    </div>
  );
};
